/**
 * Domivo: смяна на главните банери.
 *
 * Съзнателно е прост: без библиотека, без плъзгане, без безкраен цикъл.
 * Три банера на началната страница не изискват карусел - изискват само да
 * се сменят и да могат да се спрат.
 *
 * Три неща, които обикновено се пропускат и тук ги има:
 *  - спира при посочване и при фокус с клавиатура, за да не отскочи под
 *    ръката на човека точно докато чете или натиска;
 *  - спира, когато табът не се гледа (Page Visibility) - иначе браузърът
 *    върти таймер и рисува на заден план без причина;
 *  - при prefers-reduced-motion смяната става без преливане (CSS слага
 *    transition 0), но СЕ сменя. Преди изобщо не тръгваше - а в Windows
 *    с изключени анимации това е настройка на цялата система, и банерите
 *    стояха на първия завинаги (07.10.2026).
 *  - спира при фокус само от клавиатура (:focus-visible). Клик с мишката
 *    също дава фокус, който остава след като мишката излезе - и смяната
 *    спираше докато човек не кликне другаде.
 */
(() => {
  class DomivoHero extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('.dmv-hero__slide')];
      this.dots = [...this.querySelectorAll('.dmv-hero__dot')];
      if (this.slides.length < 2) return;

      this.index = 0;
      this.interval = parseInt(this.dataset.interval, 10) || 6000;

      const prev = this.querySelector('.dmv-hero__arrow--prev');
      const next = this.querySelector('.dmv-hero__arrow--next');
      if (prev) prev.addEventListener('click', () => this.go(this.index - 1));
      if (next) next.addEventListener('click', () => this.go(this.index + 1));

      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          this.go(i);
          this.restart();
        });
      });

      this.addEventListener('pointerenter', () => this.stop());
      this.addEventListener('pointerleave', () => this.start());
      this.addEventListener('focusin', (e) => {
        if (e.target.matches && e.target.matches(':focus-visible')) this.stop();
      });
      this.addEventListener('focusout', () => this.start());
      document.addEventListener('visibilitychange', () => {
        document.hidden ? this.stop() : this.start();
      });

      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    go(i) {
      this.index = (i + this.slides.length) % this.slides.length;
      this.slides.forEach((s, k) => {
        const on = k === this.index;
        s.classList.toggle('is-active', on);
        // Скритите слайдове се махат и от четците, и от табването -
        // иначе Tab минава през невидими връзки.
        if (on) {
          s.removeAttribute('aria-hidden');
          s.removeAttribute('tabindex');
        } else {
          s.setAttribute('aria-hidden', 'true');
          s.setAttribute('tabindex', '-1');
        }
      });
      this.dots.forEach((d, k) => {
        d.classList.toggle('is-active', k === this.index);
        d.setAttribute('aria-selected', k === this.index ? 'true' : 'false');
      });
    }

    start() {
      if (this.timer) return;
      this.timer = setInterval(() => this.go(this.index + 1), this.interval);
    }

    stop() {
      clearInterval(this.timer);
      this.timer = 0;
    }

    restart() {
      this.stop();
      this.start();
    }
  }

  if (!customElements.get('domivo-hero')) {
    customElements.define('domivo-hero', DomivoHero);
  }
})();
